import { TStateReducer } from '../types';

import { actionTypes } from './constants';

export const createReducer = <T>() => (
    state: TStateReducer<T>,
    action: { type: keyof typeof actionTypes; payload?: unknown }
): TStateReducer<T> => {
    const { type, payload } = action;

    switch (type) {
        case actionTypes.RESET_STATE: {
            return {
                isLoading: false,
                isLoaded: false,
                data: undefined,
                error: null
            };
        }

        case actionTypes.FETCH_INIT: {
            return {
                ...state,
                isLoading: true,
                error: null
            };
        }

        case actionTypes.FETCH_SUCCESS: {
            return {
                ...state,
                isLoading: false,
                isLoaded: true,
                error: undefined,
                data: payload as T
            };
        }

        case actionTypes.FETCH_FAILURE: {
            return {
                ...state,
                data: undefined,
                isLoading: false,
                error: payload
            };
        }

        case actionTypes.RESET_LOADING: {
            return {
                ...state,
                isLoading: false
            };
        }

        default:
            throw new Error(`Unknown action type ${type}`);
    }
};
